__turbopack_context__.v({
  "container": "Container-module-scss-module__JlzzPW__container",
  "extraNarrow": "Container-module-scss-module__JlzzPW__extraNarrow",
  "fade-in": "Container-module-scss-module__JlzzPW__fade-in",
  "max": "Container-module-scss-module__JlzzPW__max",
  "narrow": "Container-module-scss-module__JlzzPW__narrow",
  "no-transform": "Container-module-scss-module__JlzzPW__no-transform",
  "rotate": "Container-module-scss-module__JlzzPW__rotate",
});
